/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertController, IonContent, IonItemSliding, IonRouterOutlet, LoadingController, ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription, interval } from 'rxjs';
import { FcmService } from '@shared/services/fcm.service';
import { MatchService } from 'src/app/services/match.service';
import { UserService } from '@shared/services/user.service';
import { Keyboard } from '@capacitor/keyboard';
import { Preferences } from '@capacitor/preferences';
import { UtilService } from '@shared/utils/util';
import { PicturesPage } from '../pictures/pictures.page';
import { PurchaseService } from 'src/app/services/purchase.service';
import { ProfileDisplayPage } from '../profile-display/profile-display.page';
import { StoreV2Page } from '../store-v2/store-v2.page';
import { StorePage } from '../store/store.page';
import { MediaService } from '@shared/services/media.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Autosize } from '@shared/components/autosize';
import { FileUploadResult } from '@awesome-cordova-plugins/file-transfer';
import { GenericResponse, VoiceRecorder } from 'capacitor-voice-recorder';
import { EventService } from '@shared/services/event.service';
import { AndroidSettings, IOSSettings } from 'capacitor-native-settings';
import { ShareProfileComponent } from '@shared/components/share-profile/share-profile.component';
import { App } from '@capacitor/app';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from 'src/app/services/validation.service';
import { WebBlocker } from '@shared/decorators/web-blocker.decorator';
import { NotAvailableComponent } from '@shared/components/not-available/not-available.component';
import { environment } from 'src/environments/environment';
import { PluginListenerHandle } from '@capacitor/core';
import { getSoulOid, hasSoulOid } from '@shared/utils/soul-id.util';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.page.html',
  styleUrls: ['./chat.page.scss'],
  providers: [FcmService, UtilService, MediaService, IonRouterOutlet]
})
export class ChatPage implements OnInit {
  @ViewChild(IonContent) content: IonContent | any;
  @ViewChild('chatInput') chatInput: any;
  public myForm: any;
  public theMsgControl: FormControl =
    new FormControl('', Validators.compose([Validators.required, Validators.maxLength(1000)]));

  private lastTap: number = 0;
  private lastTappedMessageId: string | null = null;
  private doubleTapThreshold: number = 400;
  
  public userData: any;
  public selfiesApproved: boolean = false;
  public otherSoul: any;
  public fromProfileDisplay: boolean = false;
  public respondedMessage: any = null;
  public respondingMessage: boolean = false;
  public showRate: boolean = true;
  messages:any = [];
  public messagesMap = new Map();
  public showFab: boolean = false;
  private showedReactionHint: boolean = false;
  private showedRespondHint: boolean = false;
  private showedReadingConfirmationCallout = false;
  private lastNewMessageId: string | any;
  private lastDay = '';
  private today : any;
  private firstOpenDate = new Date();
  private refreshSubs: Subscription = new Subscription();
  private pauseSubs: Subscription = new Subscription();
  private resumeSubs: Subscription = new Subscription();
  private appPausedListener?: PluginListenerHandle;
  private appResumedListener?: PluginListenerHandle;
  private keyboardShowListener?: PluginListenerHandle;
  /** Fica falso ao sair da tela, para um listener que ainda estava registrando nao vazar. */
  private ouvindoTeclado = false;
  //  private keyboardSubscription : Subscription = new Subscription();
  private msgsSent = 0;
  public isLoaded: boolean = false;
  private isAndroid: boolean = true;
  private canUseWithoutAds: boolean = false;
  private userIsTyping: boolean = false;
  private elapsed = 60;

  /**
   * Ha gravacao aguardando revisao? E' isto que a barra de ouvir/descartar/enviar
   * observa — NAO o recordedAudioPath.
   *
   * O caminho do arquivo nao serve de sinal: na web o uploadAudio ignora ele por
   * completo e manda a base64 (user.service.ts:1610-1612), e o stopRecord() do
   * MediaService devolve undefined se o gravador nao entregar recordDataBase64.
   * Amarrar o *ngIf ao caminho fazia a barra nunca aparecer nesses casos — o
   * compositor voltava e a gravacao se perdia em silencio.
   */
  public hasRecordedAudio: boolean = false;

  /** Caminho do arquivo gravado, quando existe. Pode ser null na web. */
  public recordedAudioPath: string | null = null;
  public clickValidateProfile: boolean = false;
  private sentNoMessagesAtFirst: boolean = false;
  private isNative: boolean = true;
  public fromVegmatchModal = false;

  public formattedelapsed = this.elapsed.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  })

  private requests: number= 0;
  private hasMarkedOnOpen = false;

  // @Output() openModalAppShare = new EventEmitter<any>()
  public goHome() {
    // Doesn't work. Will need to pop and in the previous screen, do the select(0). 
    //Check how to return a value to the previous screen
    console.log('goHome called..');
    // this.navCtrl.pop();
    // this.navCtrl.parent.select(2);
  }

  public showProfileShare: boolean = false;
  public showAlertRateNowChat: boolean = false;
  private eventSubscription: Subscription|any;

  // private unregisterFunction: Function;

  public backButton: Subscription|any;
  constructor(
    private userService: UserService,
    public modalCtrl: ModalController,
    public platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    public matchService: MatchService,
    private translate: TranslateService,
    public mediaSP: MediaService,
    public navParams: NavParams,
    private purchaseServiceProvider: PurchaseService,
    public toastCtrl: ToastController,
    private analytics: AnalyticsService,
    public alertCtrl: AlertController,
    private util: UtilService,
    public eventService: EventService,
    public valitationService: ValidationService,
    public loadingCtrl: LoadingController,
    public element: ElementRef
  ) {
    this.isNative = this.util.isNative();
    this.myForm = new FormGroup({
      msgControl: this.theMsgControl
    });
  }

  ngOnInit() {
  }

  sendSocketMessage(_theMsg: string) {
    // this.socket.emit('send-message', { text: theMsg });
  }

  sendMyChat(_myID: string, _otherSoulID: string) {
    // this.socket.emit('add-myChat', { me: myID, otherSoul: otherSoulID });
  }

  async ionViewWillEnter() {
    this.backButton = this.platform.backButton.subscribe(() => {
      this.dismiss();
    });

    await this.viewInfo();

    this.route.queryParamMap.subscribe(params => {
      this.selfiesApproved = params.get('selfiesApproved') === 'true';
    });

    Preferences.get({key:'chatFirstOpenDate'}).then((val:any)=>{
      val = val.value ? JSON.parse(val.value) : null;
      if(val == null){
        Preferences.set({key:'chatFirstOpenDate', value: JSON.stringify(new Date())}).then(()=>{
          console.log('chat first open date stored');
        })
      } else {
        this.firstOpenDate = new Date(val);
      }
    })

    // connect to socket.io server
    // this.socket.connect();

    this.sendMyChat(this.userData?._id.$oid, this.otherSoul._id.$oid);

    this.getMessages().subscribe(aMessage => {
      console.log('Message received: ' + JSON.stringify(aMessage));
    });

    this.receiveReactToMessage().subscribe((reaction:any) => {
      console.log('receiveReactToMessage received: ' + JSON.stringify(reaction));

      const msgId = reaction['messageId'];
      console.log('msgId: ' + msgId);
      if (!msgId) {
        return;
      }

      const message = this.messagesMap.get(msgId);
      if (!message) {
        return;
      }

      message.reaction = 1;
      this.messagesMap.set(msgId, message);
      this.messages = Array.from(this.messagesMap.values());
    });

    this.receiveUnReactToMessage().subscribe((reaction:any) => {
      console.log('receiveUnReactToMessage received: ' + JSON.stringify(reaction));

      const msgId = reaction['messageId'];
      console.log('msgId: ' + msgId);
      if (!msgId) {
        return;
      }

      const message = this.messagesMap.get(msgId);
      if (!message) {
        return;
      }

      message.reaction = null;
      this.messagesMap.set(msgId, message);
      this.messages = Array.from(this.messagesMap.values());
    });
  }

  receiveReactToMessage(): Observable<object> {
    const observable = new Observable<object>(observer => {
      // this.socket.on('reactToMessage', (data:any) => {
        // update observable when the 'message' event is sent from the server
        observer.next({});
      // });
    });
    return observable;
  }

  receiveUnReactToMessage(): Observable<object> {
    const observable = new Observable<object>(observer => {
      // this.socket.on('unreactToMessage', (data:any) => {
        // update observable when the 'message' event is sent from the server
        observer.next({});
      // });
    });
    return observable;
  }

  getMessages(): Observable<object> {
    const observable = new Observable<object>(observer => {
      // this.socket.on('message', (data:any) => {
        // update observable when the 'message' event is sent from the server
        observer.next({});
      // });
    });
    return observable;
  }

  async viewInfo() {
    this.userData = this.navParams.get('me');
    this.fromProfileDisplay = this.navParams.get('fromProfileDisplay');
    this.canUseWithoutAds = this.purchaseServiceProvider.canUseWithoutAds(this.userData)
    console.log('canUseWithoutAds: ' + this.canUseWithoutAds);
    this.otherSoul = this.navParams.get('otherSoul');
    this.replyWithoutLikeChosen = false;
    this.isAndroid = this.platform.is('android');
    this.fromVegmatchModal = this.navParams.get('fromVegmatchModal') || false;

    if (!hasSoulOid(this.otherSoul)) {
      console.warn('Chat opened without a valid otherSoul id', this.otherSoul);
      this.modalCtrl.dismiss();
      return;
    }

    const hydrated = await this.hydrateUserFromStorage();
    if (!hydrated) {
      console.log('No USER_DATA in storage when opening chat.');
      this.modalCtrl.dismiss('logout');
      return;
    }

    const isCurrentSession = await this.sessionStillMatchesCurrentUser();
    if (!isCurrentSession) {
      console.log('Detected stale chat session before loading chat data.');
      this.modalCtrl.dismiss('logout');
      return;
    }

    this.markReadOnOpenOnce();

    this.isNative = this.util.isNative();
    this.loadProfilePictureAndMessages();
    this.today = this.userService.formatDate(new Date(), this.userData);


    this.subscribeRefresher();

    this.platform.ready().then(async () => {
      this.isAndroid = this.platform.is('android');
      await this.removeAppStateListeners();

      this.appPausedListener = await App.addListener('appStateChange', (state) => {
        if (!state.isActive) {
          console.log('[CHAT] App paused');
          this.unSubscribeRefresher();
        }
      });

      // Subscribing to the resume event
      this.appResumedListener = await App.addListener('appStateChange', (state) => {
        if (state.isActive) {
          console.log('[CHAT] App resumed');
          this.subscribeRefresher();
        }
      });



    });
  }

  async startRecord() {
    // O gate vale para QUALQUER resposta, nao so para texto. Antes so o `send()` checava, e
    // o audio passava direto pelo paywall. Esconder o botao fecha pela UI; isto fecha pelo
    // codigo, que e o que vale.
    if (this.recadinhoReceiverGate) {
      this.util.presentToast(
        this.toastCtrl,
        this.translate.instant('likeBackToChatFree', { name: this.otherSoul?.firstName ?? '' }),
        3000,
      );
      return;
    }

    const perm: GenericResponse = await VoiceRecorder.hasAudioRecordingPermission();
    if (perm.value !== true) {
      const req: GenericResponse = await VoiceRecorder.requestAudioRecordingPermission();
      if (req.value !== true) {
        this.requests++;
        if (this.requests >= 2) {
          const message = this.translate.instant('pleaseAuthorizeMicrophoneAccess');
          if (!this.util.isNative()) {
            this.util.presentToast(this.toastCtrl, message, 3000);
          } else {
            this.util.showModalAlertRequestPermission(message, AndroidSettings.ApplicationDetails, IOSSettings.App);
          }
        }
        return;
      }
    }

    this.elapsed = 60;
    this.formattedelapsed = this.elapsed.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    });
    this.mediaSP.startRecord();
    this.incrementElapsed();
  }

  incrementElapsed() {
    setTimeout(() => {
      if (this.elapsed == 1) {
        this.stopRecord();// atingiu 60s: encerra e deixa em revisao
        return;
      }
      this.elapsed -= 1;
      this.formattedelapsed = this.elapsed.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })
      if (this.mediaSP.recording) {
        this.incrementElapsed();
      }
    }, 980);// assuming the logic will take around 20ms
  }

  /**
   * Encerra a gravacao e entra em REVISAO — NAO envia.
   *
   * Antes daqui saia direto um sendAudio(). O pedido do Alex e poder ouvir antes
   * de mandar, entao o audio fica retido em recordedAudioPath e o rodape mostra
   * ouvir / descartar / enviar. Quem quiser o caminho de um toque usa o
   * stopAndSend(), que o botao de enviar do rodape de gravacao chama.
   */
  async stopRecord() {
    const generatedFilePath = await this.mediaSP.stopRecord()
    console.log('generatedFilePath: ' + generatedFilePath);
    console.log(generatedFilePath);
    console.log(this.mediaSP.fileName)

    if (!generatedFilePath && !this.mediaSP.lastRecordBase64) {
      return;
    }

    this.recordedAudioPath = generatedFilePath ?? null;
    this.hasRecordedAudio = true;
  }

  /** Encerra e envia num toque so (botao de enviar do rodape de gravacao). */
  async stopAndSend() {
    await this.stopRecord();
    this.sendRecordedAudio();
  }

  /** Envia o audio que esta em revisao. */
  sendRecordedAudio() {
    if (!this.hasRecordedAudio) {
      return;
    }
    this.mediaSP.stopPreview();
    const path = this.recordedAudioPath;
    this.hasRecordedAudio = false;
    this.recordedAudioPath = null;
    // Path vazio e' esperado na web; o sendAudio repassa a base64 do MediaService.
    this.sendAudio(path as string);
  }

  /** Descarta o audio em revisao, sem enviar. */
  discardRecordedAudio() {
    this.mediaSP.stopPreview();
    this.hasRecordedAudio = false;
    this.recordedAudioPath = null;
    this.mediaSP.deleteLastLocalAudioIfExists();
  }

  /** Tocando a previa? O template liga aqui em vez de alcancar o servico. */
  get isPreviewPlaying(): boolean {
    return this.mediaSP.previewPlaying;
  }

  /** Ouvir o audio gravado antes de enviar; tocar de novo pausa. */
  togglePreview(): void {
    this.mediaSP.togglePreview();
  }


  private loadProfilePictureAndMessages() {
    this.userData.profilePic = PicturesPage.gray;// Set initially

    const _theFile: string = 'picture0.jpg';

    let i: number = 0;
    for (i = 0; i < 8; i++) {
      const aPicName = 'picture' + i;
      const aPic = this.userData[aPicName];
      if (aPic != null) {
        this.userData.profilePic = this.userService.getImageURL(aPic.$oid);
        break;
      }
    }
    this.loadMessages(this.userData, this.otherSoul);

  }

  public unSubscribeRefresher() {
    this.refreshSubs.unsubscribe();
  }

  private async removeAppStateListeners() {
    if (this.appPausedListener) {
      await this.appPausedListener.remove();
      this.appPausedListener = undefined;
    }
    if (this.appResumedListener) {
      await this.appResumedListener.remove();
      this.appResumedListener = undefined;
    }
  }

  private async hydrateUserFromStorage(): Promise<boolean> {
    const currentSession = await Preferences.get({ key: 'USER_DATA' });
    const currentUserData = currentSession.value ? JSON.parse(currentSession.value) : null;
    if (!currentUserData || !hasSoulOid(currentUserData)) {
      return false;
    }
    this.userData = currentUserData;
    return true;
  }

  private async sessionStillMatchesCurrentUser(): Promise<boolean> {
    const navMe = this.navParams.get('me');
    const currentSession = await Preferences.get({ key: 'USER_DATA' });
    const currentUserData = currentSession.value ? JSON.parse(currentSession.value) : null;
    if (!currentUserData || !navMe) {
      return false;
    }

    return getSoulOid(currentUserData) === getSoulOid(navMe)
      && currentUserData?.hash === navMe?.hash;
  }

  public subscribeRefresher() {
    this.refreshSubs.unsubscribe();
    this.refreshSubs = interval(1000 * 5).subscribe(async _x => {
      if (this.userData == null) {
        // this.unregisterFunction();
        this.modalCtrl.dismiss('logout');
        return;
      }

      const isCurrentSession = await this.sessionStillMatchesCurrentUser();
      if (!isCurrentSession) {
        console.log('Detected stale chat session. Stopping refresher for previous login.');
        this.unSubscribeRefresher();
        this.modalCtrl.dismiss('logout');
        return;
      }

      // SK-54 — este bloco roda a cada 5s enquanto o chat esta aberto. Serializar
      // userData aqui custava ~216 KB de string por ciclo (medido em device), mais
      // outra alocacao na concatenacao e a travessia da ponte ate o logcat, que
      // ainda fatia em blocos de 4 KB. Em aparelho com pouca memoria vira pico de
      // GC periodico — o tipo de engasgo que faz o IME piscar.
      if (this.messages.length > 0) {
        this.loadNewMessages(this.userData, this.otherSoul, this.messages[this.messages.length - 1 - this.msgsSent]);
      }
    });
  }

  async openProfile() {

    // Abre o perfil SEMPRE como modal por cima do chat, para o "voltar" do perfil retornar
    // ao chat (e não ao feed). Antes, quando o chat vinha de um perfil (fromProfileDisplay),
    // tocar na foto fechava o chat e revelava o perfil de origem — cujo voltar ia pro feed.

    const modal = this.modalCtrl.create({component:ProfileDisplayPage, componentProps: { theSoul: this.otherSoul }});
    (await modal).onDidDismiss().then((val) => {
      console.log('Data returned from ProfileDisplayPage modal: ' + JSON.stringify(val.data));

      if (val.data == 'logout') {
        // this.unregisterFunction();
        this.modalCtrl.dismiss('logout');
        return;
      }

      if (val.data != null && val.data == 'removed') {
        this.dismiss();
        return;
      }

      // Voltou do perfil: como o perfil abre como modal por cima, o chat NÃO dispara
      // ionViewWillEnter, então nada recarrega sozinho. Reativa o poll e busca as mensagens
      // novas na hora. Se um elogio foi enviado no perfil (role recadinhoSent), faz reload
      // completo para trazer a foto/pictureId da mensagem.
      this.subscribeRefresher();
      if (val.role === 'recadinhoSent') {
        this.loadMessages(this.userData, this.otherSoul);
      } else if (this.messages?.length) {
        this.loadNewMessages(this.userData, this.otherSoul, this.messages[this.messages.length - 1 - this.msgsSent]);
      }

    });

    (await modal).present();
  }

  @WebBlocker()
  async openAvocadoStore() {
    this.analytics.registerEvent(AnalyticsService.avocado);
    this.analytics.registerEvent(AnalyticsService.avcdFromReadConf);
    const modal = this.modalCtrl.create({component: StoreV2Page, componentProps: {me: this.userData, type: "avocado_club", from:'chat'}, showBackdrop:true, backdropDismiss:true});
    (await modal).present();
  }

  markSentRead() {
    console.log('this.messages.length: ' + this.messages.length);
    for (let i = this.messages.length - 1; i >= 0; i--) {
      const aMessage = this.messages[i];
      if (aMessage.position == 'right') {
        if (!aMessage.read) {
          aMessage.read = true;
        } else {
          // if it was already marked ready, no need to keep going.
          return;
        }
      }
    }
  }

  loadNewMessages(userData: any, otherSoul: any, lastMsg: any) {

    const theObs = this.userService.getNewMessages(userData, otherSoul, lastMsg);

    theObs.subscribe(async data => {
      console.log('getNewMessages subscribe entered');
      if (data != '{not ok}') {
        this.consecutiveNotOk = 0;
        console.log('data = ' + JSON.stringify(data));
        data = JSON.parse(data);

        if (data.lastRead != undefined) {
          // No new message. Handle wheather last message has been read or not
          console.log('No new message. Handle wheather last message has been read or not');
          if (data.lastRead) {
            // mark my messages read
            this.markSentRead();
          }
        }

        if (data != null && data.length > 0 && this.lastNewMessageId != data[0]._id.$oid) {
          let nextHint = null;
          if (!this.showedReactionHint) {
            nextHint = "reaction";
          } else if (!this.showedRespondHint) {
            nextHint = "respond";
          }

          for (let i = data.length - 1; i > -1; i--) {
            this.markSentRead();

            const aMessage = data[i];
            const d = new Date(aMessage.time * 1000);
            aMessage.date = this.userService.formatDate(d, this.userData);
            aMessage.time = this.userService.formatTime(d);
            if (aMessage.date != this.lastDay) {
              aMessage.newday = true;
              this.lastDay = aMessage.date;
              if (aMessage.date == this.today) {
                aMessage.date = 'Today';
              }

            }
            
            // Normalize read status to ensure it's always a boolean
            if (aMessage.read === null || aMessage.read === undefined) {
              aMessage.read = false;
            }

            // Backend stores reaction as string ("1"); UI expects number 1
            if (aMessage.reaction == 1) {
              aMessage.reaction = 1;
            }
            
            if (aMessage.sent) {
              aMessage.position = 'right';

              if (!this.showedReadingConfirmationCallout && !this.purchaseServiceProvider.isPremium(this.userData) && d > this.firstOpenDate) {
                aMessage.readingConfirmationCallout = true;
                this.showedReadingConfirmationCallout = true;
              }
            } else {
              aMessage.position = 'left';
              aMessage.img = otherSoul.firstPic

              if (nextHint == "reaction") {
                aMessage.reactionHint = true;
                nextHint = "respond";
                this.showedReactionHint = true;
              } else if (nextHint == "respond") {
                aMessage.respondHint = true;
                nextHint = null;
                this.showedRespondHint = true;
              }
            }


            const msg = this.messageText(aMessage);
            console.log('msg: ' + msg)
            if (msg.startsWith('{') && msg.endsWith('}')) {
              try {
                console.log('Will set filename..');
                const audioMsg = JSON.parse(msg);
                aMessage.filename = audioMsg.filename;
                aMessage.duration = audioMsg.duration;
                aMessage.fileId = audioMsg.fileId;
                
              } catch (error) {
                console.log("Text message starting with { and ending with }. Error Trying to parse text as JSON");
                aMessage.message = msg;
              }
            } else {
              aMessage.message = msg;
            }

            this.lastNewMessageId = aMessage._id.$oid;
            this.messagesMap.set(aMessage._id.$oid, aMessage);
            this.messages = Array.from(this.messagesMap.values());

          }

          this.markConversationRead(true);

          this.scrollToBottom();
          this.msgsSent = 0;

        }

      } else {

        this.consecutiveNotOk++;
        console.log('getNewMessages received {not ok}. Consecutive count: ' + this.consecutiveNotOk);
        if (this.consecutiveNotOk < ChatPage.NOT_OK_LOGOUT_THRESHOLD) {
          return;
        }
        this.unSubscribeRefresher();
        await this.userService.clearLocalStorage();
        this.userData = null;
        // this.unregisterFunction();
        this.modalCtrl.dismiss('logout');
        return;

      }


    },
      err => {
        if (this.countErrorMsg == 10) {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          this.countErrorMsg = 0;
        } else {
          this.countErrorMsg++;
        }
        console.log('Error: ' + JSON.stringify(err));
      })

  }

  private countErrorMsg: number = 0;
  private consecutiveNotOk: number = 0;
  private static readonly NOT_OK_LOGOUT_THRESHOLD = 3;

  /** Marks match or messages read once when chat opens (after session is valid). */
  private markReadOnOpenOnce(): void {
    if (this.hasMarkedOnOpen) {
      return;
    }
    this.hasMarkedOnOpen = true;

    if (this.otherSoul?.lastMessage != null) {
      this.markConversationRead(true);
    } else if (this.otherSoul?.newBadge) {
      this.markConversationRead(false);
    }
  }

  private markConversationRead(isMessage: boolean): void {
    const theObs = this.userService.markRead(this.userData, this.otherSoul, isMessage);
    theObs.subscribe(
      (data) => {
        console.log('markConversationRead response: ' + JSON.stringify(data));
        const response = data != null ? String(data) : '';
        const ok = response.includes('{ok}') && !response.includes('{not ok}');
        if (ok) {
          this.matchService.applyReadLocally(this.otherSoul);
        }
      },
      (err) => {
        console.log('markConversationRead error: ' + JSON.stringify(err));
      }
    );
  }

  /** Destinatário escolheu responder sem curtir (UI); a cobrança é no sendMessage. */
  public replyWithoutLikeChosen: boolean = false;

  /**
   * A conversa é um Recadinho (Intro) pendente: existe SEM match. Um chat sem match só é
   * criado por um recadinho, então `match === false` identifica esse estado com segurança
   * (usa `=== false` explícito para nunca afetar conversas cujo objeto não traga o campo).
   */
  get isRecadinhoChat(): boolean {
    return this.otherSoul?.match === false;
  }

  /** True se o documento de chat é um elogio (compliment / legacy recadinho). */
  private isComplimentFlag(msg: any): boolean {
    return msg?.compliment === true || msg?.compliment === 'true'
      || msg?.recadinho === true || msg?.recadinho === 'true';
  }

  /**
   * Mensagem de elogio na conversa (pode existir mesmo com match).
   * Sem flag, em chat sem match assume a 1ª (mais antiga).
   */
  get recadinhoMessage(): any {
    const byFlag = this.messages?.find((m: any) => this.isComplimentFlag(m));
    if (byFlag) {
      return byFlag;
    }
    return this.isRecadinhoChat ? this.messages?.[0] : null;
  }
  get iSentRecadinho(): boolean {
    return this.isRecadinhoChat && this.recadinhoMessage?.position === 'right';
  }
  get iReceivedRecadinho(): boolean {
    return this.isRecadinhoChat && this.recadinhoMessage?.position === 'left';
  }

  /** True para qualquer mensagem marcada como Elogio (com ou sem match). */
  isRecadinhoMessage(aMessage: any): boolean {
    if (!aMessage) { return false; }
    // Um Elogio carrega a foto elogiada (pictureId). Detecta por ele para a foto/selo
    // continuarem aparecendo MESMO depois de a conversa virar match (quando recadinhoMessage
    // é null) — e para marcar todas as mensagens de elogio, não só a primeira.
    const raw = aMessage.pictureId;
    const pid = raw?.$oid ?? raw;
    if (pid != null && pid !== '') { return true; }
    // Fallback p/ chats antigos sem pictureId: a 1ª msg de um chat sem match é o recadinho.
    return aMessage === this.recadinhoMessage;
  }

  /**
   * URL da miniatura da foto elogiada. Usa o pictureId enviado pelo backend na mensagem
   * do Elogio. Retorna null se a mensagem não trouxer a foto.
   */
  complimentPhotoUrl(aMessage: any): string | null {
    const raw = aMessage?.pictureId;
    // O backend pode mandar o id como string ou como { $oid: '...' } (padrão do codebase).
    const pid = raw?.$oid ?? raw;
    return pid != null && pid !== '' ? this.userService.getImageURL(pid) : null;
  }

  /**
   * A miniatura do Elogio aparece nesta mensagem? A mesma condicao vale para o *ngIf da foto e
   * para a classe da bolha que abre espaco para o selo acima dela.
   */
  mostraFotoDoElogio(aMessage: any): boolean {
    return this.isRecadinhoMessage(aMessage)
      && !!this.complimentPhotoUrl(aMessage)
      && !this.failedComplimentPhotos.has(aMessage?._id?.$oid);
  }

  /**
   * Destinatário: precisa curtir de volta (grátis) ou escolher responder sem curtir
   * (cada sendMessage cobra 1 spark no servidor).
   */
  /**
   * Duracao do audio no formato do mockup: "0:20", e nao "20s".
   *
   * Trunca em vez de arredondar porque `currentTimePlayed` e float e cresce continuamente
   * durante a reproducao: arredondando, o contador mostraria o segundo seguinte antes de ele
   * comecar, e um audio de 20s exibiria "0:21" no fim.
   *
   * Aguenta mais de um minuto — o `formattedelapsed` da GRAVACAO nao serve aqui, porque ele
   * depende de um "0:" fixo escrito no template.
   */
  public formatarDuracaoDoAudio(segundos: number | null | undefined): string {
    const total = Math.max(0, Math.floor(Number(segundos) || 0));
    const minutos = Math.floor(total / 60);
    const resto = total % 60;
    return minutos + ':' + String(resto).padStart(2, '0');
  }

  get recadinhoReceiverGate(): boolean {
    return this.iReceivedRecadinho && !this.replyWithoutLikeChosen;
  }

  /** Resposta paga a elogio sem match (cobra 1 spark no sendMessage). */
  private isPaidComplimentReply(): boolean {
    return this.otherSoul?.match === false && this.replyWithoutLikeChosen && this.iReceivedRecadinho;
  }

  /** Remetente: aguardando o like de volta; não pode mandar mais mensagens até virar match. */
  get recadinhoSenderLock(): boolean {
    return this.iSentRecadinho;
  }

  /** Info do ícone de Elogio: com match só explica; sem match convida a curtir de volta. */
  async showRecadinhoInfo() {
    const name = this.otherSoul?.firstName ?? '';
    let message = this.translate.instant('thisMessageWasAnIntro');
    if (this.otherSoul?.match === false) {
      message += ' ' + this.translate.instant('likeBackToChatFree', { name });
    }
    const alert = await this.alertCtrl.create({
      message,
      buttons: [this.translate.instant('ok')],
    });
    await alert.present();
  }

  /** Curtir de volta: como o remetente do recadinho já curtiu, isso fecha o match. */
  likeBackFromRecadinho() {
    this.userService.likeSoul(this.userData?._id.$oid, this.otherSoul._id.$oid, this.userData)
      .subscribe((data: any) => {
        if (data == '{not ok}') {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          return;
        }
        // Like mútuo → vira match e a conversa destrava.
        this.otherSoul.match = true;
      });
  }

  /**
   * Escolhe responder sem curtir: libera a UI e pré-seleciona o elogio como mensagem respondida.
   * Cada envio cobra 1 spark no servidor (com confirmação).
   */
  async replyWithoutLike() {
    if ((this.userData?.coins ?? 0) < 1) {
      const modal = await this.modalCtrl.create({
        // Loja de SPARKS na vantagem do Elogio (origin 'Intro'), não a de Avocado (StoreV2).
        component: StorePage,
        componentProps: { me: this.userData, type: 'carrot', origin: 'Intro' },
        showBackdrop: true, backdropDismiss: true,
      });
      await modal.present();
      return;
    }
    this.replyWithoutLikeChosen = true;
    if (this.recadinhoMessage) {
      this.respondedMessage = this.recadinhoMessage;
      this.respondingMessage = true;
    }
  }

  /** Confirma cobrança de 1 spark antes de responder ao elogio sem match. */
  private async confirmPaidComplimentReply(): Promise<boolean> {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('confirm'),
      message: this.translate.instant('confirmReplyComplimentForOneCarrot'),
      buttons: [
        { text: this.translate.instant('cancel'), role: 'cancel' },
        { text: this.translate.instant('confirm'), role: 'confirm' },
      ],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
    return role === 'confirm';
  }

  /**
   * Id do elogio para inResponseTo na resposta paga.
   * Prioriza o elogio que o usuário selecionou; senão, o primeiro da conversa.
   */
  private resolvePaidComplimentInResponseToId(): string | null {
    if (this.respondedMessage && this.isRecadinhoMessage(this.respondedMessage)) {
      return this.respondedMessage._id?.$oid ?? null;
    }
    return this.recadinhoMessage?._id?.$oid ?? null;
  }

  /** Mantém selecionado o elogio respondido (ou o padrão) após um envio pago. */
  private keepPaidComplimentReplySelection() {
    const keep = (this.respondedMessage && this.isRecadinhoMessage(this.respondedMessage))
      ? this.respondedMessage
      : this.recadinhoMessage;
    if (keep) {
      this.respondedMessage = keep;
      this.respondingMessage = true;
    }
  }

  private messageText(aMessage: any): string {
    const raw = aMessage?.message;
    if (raw == null) {
      return '';
    }
    return typeof raw === 'string' ? raw.trim() : String(raw).trim();
  }

  async ionViewWillLeave() {
    // Sair do chat com a previa tocando deixaria o audio por cima da tela seguinte.
    this.mediaSP.stopPreview();
    this.desligarAjusteDeTecladoNaWeb();
    this.soltarAlturaDoCampo();
    await this.soltarRolagemAposTeclado();
    if(this.platform.is('android')) {
      if(this.backButton){
        this.backButton.unsubscribe();
      }
    }
    if (this.isNative && this.sentNoMessagesAtFirst && this.sentOneThisTime) {

      if(localStorage.getItem('showProfileShare')) {

        localStorage.removeItem('showProfileShare')
        // this.eventService.publish('openModalAppShare', true);

        const modal = await this.modalCtrl.create({
          component: ShareProfileComponent,
          componentProps: {
            userId: this.userData?._id.$oid,
            shareBaseUrl: this.userService.getShareBaseUrl(),
            shareTextKey: 'shareYourProfileText',
            shareTitleKey: 'shareYourProfile'
          },
          cssClass: 'custom-class-modal' 
        });
        modal.present();

      }else if(localStorage.getItem('showAlertRateNowChat')){
        localStorage.removeItem('showAlertRateNowChat')
        
        localStorage.setItem('showProfileShare', 'true')
        
        this.util.showAlertRateNowChat();

      } else{
        localStorage.setItem('showAlertRateNowChat', 'true')
        this.util.showAlertRateNow();
      }
    }

    this.unSubscribeRefresher();
    await this.removeAppStateListeners();
    this.pauseSubs.unsubscribe();
    this.resumeSubs.unsubscribe();
    this.matchService.chattingToSoul = null;

    console.log('ionViewWillLeave Disconnect socket');
    // this.socket.disconnect();

    console.log("Stop other audio...")
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatPage');
    if (this.content != undefined && this.content != null) {
      this.content.scrollToPoint(0, 999999999, 300);
    }
  }


  /** Desfaz os listeners de viewport da web; indefinido quando nao ha nenhum. */
  private soltarAjusteDeTeclado?: () => void;

  /**
   * No Safari o teclado NAO encolhe o layout viewport — so o visual. O
   * `ion-footer` do chat fica posicionado no fim de uma pagina de altura cheia,
   * portanto ATRAS do teclado, e o Safari rola o documento para trazer o campo
   * a vista: e o espaco vazio reportado. A tela de login nao sofre porque nao
   * tem rodape, so `ion-content`, que rola normalmente.
   *
   * A correcao mede quanto do layout viewport o teclado cobre e publica em
   * `--chat-keyboard-inset`; o SCSS sobe o rodape esse tanto.
   *
   * SO NA WEB, de proposito. No nativo quem redimensiona e o sistema, via
   * `windowSoftInputMode`, com `KeyboardResize.Native` no plugin. Somar um
   * ajuste nosso ali reproduziria a disputa de layout documentada na SK-54, que
   * causava o bounce do teclado.
   */
  private ligarAjusteDeTecladoNaWeb(): void {
    if (this.util.isNative()) return;

    const vv = window.visualViewport;
    if (!vv) return;   // navegador antigo: sem a API, fica como esta hoje

    const aplicar = () => {
      // Quanto do LAYOUT viewport sobra abaixo do visual viewport: e o pedaco
      // coberto pelo teclado.
      //
      // A referencia e `clientHeight`, e nao a altura da janela. Medido no
      // aparelho sem teclado: janela 473, clientHeight 473, vv.height 473,6 —
      // a altura da janela ja vem MENOR que o visual viewport. No Safari ela
      // tambem encolhe com o teclado, entao a subtracao dava ~0 e o rodape nao
      // subia: foi por isso que a primeira versao nao funcionou. O
      // `clientHeight` e o layout viewport e nao encolhe com o teclado.
      const layout = document.documentElement.clientHeight;
      const coberto = Math.max(0, layout - (vv.height + vv.offsetTop));
      document.documentElement.style.setProperty('--chat-keyboard-inset', `${coberto}px`);
    };

    aplicar();
    vv.addEventListener('resize', aplicar);
    vv.addEventListener('scroll', aplicar);

    this.soltarAjusteDeTeclado = () => {
      vv.removeEventListener('resize', aplicar);
      vv.removeEventListener('scroll', aplicar);
      // A variavel e global: deixa-la para tras afetaria outras telas.
      document.documentElement.style.removeProperty('--chat-keyboard-inset');
    };
  }

  private desligarAjusteDeTecladoNaWeb(): void {
    this.soltarAjusteDeTeclado?.();
    this.soltarAjusteDeTeclado = undefined;
  }

  private observadorDoCampo?: ResizeObserver;

  /**
   * Mantem a conversa colada no fim quando o CAMPO muda de altura.
   *
   * Sem isto, cada linha nova empurrava a ultima mensagem para fora da tela e nada compensava:
   * o `scrollToBottom` ja existia e era chamado em seis lugares, nenhum deles a mudanca de
   * altura do campo. Com o teto de 5 linhas o campo para de crescer, mas ate la ele ainda come
   * ate 80px da conversa — e ao apagar linhas ele devolve o espaco, o que tambem desalinha.
   *
   * `ResizeObserver` e nao o evento de digitacao porque o `autoGrow` do Ionic aplica a altura
   * num `writeTask`, depois do evento: no handler do `ionInput` a altura ainda e a antiga.
   */
  private observarAlturaDoCampo(): void {
    const host = (this.chatInput as any)?.el as HTMLElement | undefined;
    // Os dois nomes: `.native-wrapper` e a marcacao moderna do Ionic 7, `.textarea-legacy-wrapper`
    // a legacy — e este campo usa a legacy, por ter so `placeholder` e nenhum label.
    const campo = host?.querySelector('.native-wrapper, .textarea-legacy-wrapper') as HTMLElement | null;
    if (!campo || typeof ResizeObserver === 'undefined') {
      return;
    }

    let alturaAnterior = campo.offsetHeight;
    this.observadorDoCampo?.disconnect();
    this.observadorDoCampo = new ResizeObserver(() => {
      const altura = campo.offsetHeight;
      if (altura === alturaAnterior) {
        return; // largura mudou, altura nao: nao ha o que compensar
      }
      alturaAnterior = altura;
      this.scrollToBottom();
    });
    this.observadorDoCampo.observe(campo);
  }

  private soltarAlturaDoCampo(): void {
    this.observadorDoCampo?.disconnect();
    this.observadorDoCampo = undefined;
  }

  /**
   * No aparelho a conversa so desce depois que o teclado terminou de abrir.
   * Rolar no `ionFocus`, ainda com o dedo no campo, move o rodape enquanto o
   * Android 16 redimensiona a janela, e o Samsung trata o toque como fora do
   * campo e fecha o teclado (Galaxy S26 Ultra).
   */
  private ligarRolagemAposTeclado(): void {
    /* So no ANDROID. O problema que isto conserta e de la: o Android 16 redimensiona a janela
       enquanto o teclado abre, e rolar nesse meio-tempo faz a skin da Samsung tratar o toque
       como fora do campo e fechar o teclado.
    
       No iOS a viewport nao encolhe do mesmo jeito, entao a rolagem no `keyboardDidShow` nao
       resolve nada ali — e o Andre relatou que o ajuste "nao funcionou bem no iOS". A guarda
       original era so `isNative`, que inclui os dois. */
    if (!this.isNative || !this.platform.is('android')) {
      return;
    }
    this.ouvindoTeclado = true;
    void this.registrarRolagemAposTeclado();
  }

  private async registrarRolagemAposTeclado(): Promise<void> {
    await this.keyboardShowListener?.remove();
    this.keyboardShowListener = undefined;
    if (!this.ouvindoTeclado) {
      return;
    }
    try {
      const handle = await Keyboard.addListener('keyboardDidShow', () => {
        this.scrollToBottom(0);
      });
      if (!this.ouvindoTeclado) {
        await handle.remove();
        return;
      }
      this.keyboardShowListener = handle;
    } catch (error) {
      console.log('keyboardDidShow listener failed: ' + error);
    }
  }

  private async soltarRolagemAposTeclado(): Promise<void> {
    this.ouvindoTeclado = false;
    await this.keyboardShowListener?.remove();
    this.keyboardShowListener = undefined;
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter ChatPage');
    this.ligarAjusteDeTecladoNaWeb();
    this.ligarRolagemAposTeclado();
    this.observarAlturaDoCampo();

    //this.loadProfilePicture();
    this.matchService.chattingToSoul = this.otherSoul._id.$oid;
    if (this.content != undefined && this.content != null) {
      this.content.scrollToPoint(0, 999999999, 300);
    }

    this.content.ionScrollEnd.subscribe((_data:any) => {

      console.log('ionScrollEnd...');
      const dimensions = this.content.getContentDimensions();

      const scrollTop = this.content.scrollTop;
      const contentHeight = dimensions.contentHeight;
      const scrollHeight = dimensions.scrollHeight;

      console.log('scrollTop: ' + scrollTop);
      console.log('contentHeight: ' + contentHeight);
      console.log('scrollHeight: ' + scrollHeight);

      if ((scrollTop + contentHeight + 200) > scrollHeight) {
        this.showFab = false;
      } else if (!this.userIsTyping) {
        this.showFab = true;
      }

    });
  }

  async loadMessages(userData: any, otherSoul: any) {
    const loader = this.loadingCtrl.create({
      message: this.translate.instant('msgOneMomentPlease'),
    });
    (await loader).present();

    const theObs = this.userService.getMessages(userData, otherSoul);

    theObs.subscribe(async data => {
      console.log('subscribe entered');
      console.log('data = ' + JSON.stringify(data));
      if (data != null && data != '{not ok}') {
        this.messages = [];
        this.sentNoMessagesAtFirst = true;
        let nextHint :any= "reaction";
        this.showedReadingConfirmationCallout = false;

        for (let i = data.length - 1; i > -1; i--) {

          const aMessage = data[i];

          const msg = this.messageText(aMessage);
          if (msg.startsWith('{') && msg.endsWith('}')) {
  
            try {
              console.log('Will set filename..');
              const audioMsg = JSON.parse(msg);
              aMessage.filename = audioMsg.filename;
              aMessage.duration = audioMsg.duration;

            } catch (error) {
              console.log("Text message starting with { and ending with }. Error Trying to parse text as JSON");
              aMessage.message = msg;
            }
          } else {
            aMessage.message = msg;
          }


          const d = new Date(aMessage.time * 1000);
          aMessage.date = this.userService.formatDate(d, this.userData);
          aMessage.time = this.userService.formatTime(d);
          if (aMessage.date != this.lastDay) {
            aMessage.newday = true;
            this.lastDay = aMessage.date;
            if (aMessage.date == this.today) {
              aMessage.date = 'Today';
            }
          }

          // Collect the owner of the message
          this.collectOwner(aMessage, data);

          // Normalize read status to ensure it's always a boolean
          if (aMessage.read === null || aMessage.read === undefined) {
            aMessage.read = false;
          }

          // Backend stores reaction as string ("1"); UI expects number 1
          if (aMessage.reaction == 1) {
            aMessage.reaction = 1;
          }

          if (aMessage.sent) {
            aMessage.position = 'right';
            aMessage.img = this.userData?.profilePic;
            this.sentNoMessagesAtFirst = false;

            if (!this.showedReadingConfirmationCallout && !this.purchaseServiceProvider.isPremium(this.userData) && d > this.firstOpenDate) {
              aMessage.readingConfirmationCallout = true;
              this.showedReadingConfirmationCallout = true;
            }
          } else {
            aMessage.position = 'left';
            aMessage.img = otherSoul.firstPic

            if (nextHint == "reaction") {
              aMessage.reactionHint = !(aMessage.reaction == 1);
              nextHint = "respond";
              this.showedReactionHint = true;
            } else if (nextHint == "respond") {
              aMessage.respondHint = true;
              nextHint = null;
              this.showedRespondHint = true;
            }
          }

          this.messagesMap.set(aMessage._id.$oid, aMessage);
          this.messages = Array.from(this.messagesMap.values());
        }
        this.isLoaded = true;

        if (data.length > 0 && this.otherSoul?.lastMessage == null) {
          this.markConversationRead(true);
        }
      }

      this.scrollToBottom();
      (await loader).dismiss();

    },
      async err => {
        this.util.showTopToastUnableToConnect(this.toastCtrl);
        (await loader).dismiss();
        console.log('Error: ' + JSON.stringify(err));
        if (this.content != undefined && this.content != null) {
          this.content.scrollToPoint(0, 999999999, 300);
        }
      })

  }


  collectOwner(aMessage: any, data: any = this.messages) {
    // Collect the owner of the message
    if (aMessage.inResponseTo && aMessage.inResponseTo.$oid) {
      const repliedMessageOid = aMessage.inResponseTo.$oid;
      const repliedMessage = data.find((msg: { _id: { $oid: any; }; }) => msg._id && msg._id.$oid === repliedMessageOid);
    console.log('repliedMessage: ' + JSON.stringify(repliedMessage));
    if (repliedMessage) {
      if (repliedMessage.position == 'right') {
        //Add translation
        aMessage.inResponseTo.owner = this.translate.instant('you');
      }
      else{
         aMessage.inResponseTo.owner = this.otherSoul.firstName;
      }
    }
    }
  }

  sendAudio(generatedFilePath: string) {

    const filename = this.mediaSP.fileName;
    console.log('filename: ' + filename)
    const duration: number = this.mediaSP.duration;
    console.log('duration: ' + duration);

    const aPromise: Promise<FileUploadResult> = this.userService.uploadAudio(
      generatedFilePath,
      this.userData,
      filename,
      { base64: this.mediaSP.lastRecordBase64, mimeType: this.mediaSP.lastRecordMimeType },
    );
    aPromise.then(async (value: FileUploadResult) => {
      console.log('FileUploadResult responseCode: ' + JSON.stringify(value.response));

      const msg = {
        msgType: 'audio',
        filename: filename,
        duration: duration,
        fileId: value.response
      };

      if (this.isPaidComplimentReply()) {
        const confirmed = await this.confirmPaidComplimentReply();
        if (!confirmed) {
          return;
        }
      }

      this.sendMsg(msg);

    }).catch(error => {
      this.util.showTopToastUnableToConnect(this.toastCtrl);
      console.log('Error uploading audio: ' + JSON.stringify(error));
    });

  }

  async showModalAlert(message:any) {
    const alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        // {
        //   text: this.translate.instant('cancel'),
        //   handler: () => {
        //     console.log('cancel clicked');
        //     return;

        //   }
        // },
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }

  async send() {
    // Destinatario de elogio sem match. No XD o campo e o botao de enviar ficam visiveis junto
    // do gate ("curta para continuar de graca ou responda sem curtir"), entao enviar texto entra
    // no fluxo pago — o mesmo do "Responder sem curtir": confere o saldo (sem saldo abre a loja)
    // e, mais abaixo, pede confirmacao antes da cobranca. Sem texto, segue o convite a curtir.
    if (this.recadinhoReceiverGate) {
      const texto = String(this.myForm.controls['msgControl'].value ?? '').trim();
      if (!texto) {
        this.util.presentToast(
          this.toastCtrl,
          this.translate.instant('likeBackToChatFree', { name: this.otherSoul?.firstName ?? '' }),
          3000,
        );
        return;
      }
      await this.replyWithoutLike();
      if (this.recadinhoReceiverGate) {
        return;
      }
    }
    this.chatInput.setFocus();
    const msg = this.myForm.controls['msgControl'].value;

    this.element.nativeElement.getElementsByTagName('textarea')[0];
    const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
    textArea.style.overflow = 'hidden';
    textArea.style.height = 'auto';

    if (!this.myForm.valid) {
      if (msg != null && msg.length > 1000) {
        this.showModalAlert(this.translate.instant('msg1000Characters'));
      }
      const as: Autosize = new Autosize(this.element)
      as.adjust();
      return;
    }

    if (this.isPaidComplimentReply()) {
      const confirmed = await this.confirmPaidComplimentReply();
      if (!confirmed) {
        return;
      }
    }

    this.myForm.controls['msgControl'].setValue('');

    this.sendMsg(msg);

    this.chatInput.setFocus();
  }

  private sentOneThisTime: boolean = false;

  sendMsg(msg:any) {
    console.log('sendMsg entered');
    this.sentOneThisTime = true;
    let respondedMessageId:any = null;
    if (this.respondedMessage != null) {
      respondedMessageId = this.respondedMessage._id.$oid;
    }
    // Resposta paga: usa o elogio selecionado; se não houver, cai no primeiro elogio.
    if (this.isPaidComplimentReply()) {
      respondedMessageId = this.resolvePaidComplimentInResponseToId() ?? respondedMessageId;
    }

    const theObs = this.userService.sendMessage(this.userData?._id.$oid, this.otherSoul._id.$oid, msg, this.userData, respondedMessageId);
    theObs.subscribe(async data => {
      console.log('sendMessage subscribe entered');
      console.log('data for sendMessage = ' + JSON.stringify(data));
      if (data == '{not ok}') {
        this.util.showTopToastUnableToConnect(this.toastCtrl);
        return;
      }
      if (data == '{No Coins}') {
        const modal = await this.modalCtrl.create({
          component: StoreV2Page,
          componentProps: { me: this.userData, type: 'coins', from: 'recadinho' },
          showBackdrop: true, backdropDismiss: true,
        });
        await modal.present();
        return;
      }
      // Resposta a elogio sem match: 1 spark cobrada no servidor
      if (this.otherSoul?.match === false && this.replyWithoutLikeChosen) {
        this.userData.coins = Math.max(0, Number(this.userData?.coins ?? 0) - 1);
        Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });
      }
      const aMessage: any = {};

      console.log(JSON.stringify(msg));
      if (typeof msg == "object") {
        aMessage.filename = msg.filename;
        aMessage.duration = msg.duration;
        aMessage.fileId = msg.fileId
      } else {
        aMessage.message = msg;
      }
      

      const d = new Date();
      aMessage.date = this.userService.formatDate(d, this.userData);
      aMessage.time = this.userService.formatTime(d);
      if (aMessage.date != this.lastDay) {
        aMessage.newday = true;
        this.lastDay = aMessage.date;
        aMessage.date = 'Today';
      }
      aMessage.position = 'right';
      this.otherSoul.theMessage = msg;
      this.otherSoul.relevantTime = aMessage.date + ' ' + aMessage.time;
      this.otherSoul.newBadge = false;

      //register sendMessage event once per device (after it actually sends)
      // Once per device for all analytics sinks (PostHog/Adjust/GA4/Meta) by design.
      this.analytics.registerEvent(AnalyticsService.sendMessageEvent, true);
      console.log("! Analytics 'message' event sent !");
      this.msgsSent++;
      aMessage.img = this.userData?.profilePic;

      try {
        const msgId = { $oid: data };
        aMessage._id = msgId;
        // Ensure read status is properly initialized
        if (aMessage.read === null || aMessage.read === undefined) {
          aMessage.read = false;
        }
        aMessage.sent = true;
        console.log('Message to add: ' + JSON.stringify(aMessage));
        if (respondedMessageId != null) {
          aMessage.inResponseTo = { $oid: respondedMessageId };
          this.collectOwner(aMessage, this.messages);
        }
        if (!this.showedReadingConfirmationCallout && !this.purchaseServiceProvider.isPremium(this.userData) && d > this.firstOpenDate) {
          aMessage.readingConfirmationCallout = true;
          this.showedReadingConfirmationCallout = true;
        }
        console.log('Message to add: ' + JSON.stringify(aMessage));
        this.messagesMap.set(aMessage._id.$oid, aMessage);
        this.messages = Array.from(this.messagesMap.values());
      } catch (error) {
        console.log('Error adding message: ' + JSON.stringify(error));
      }

      // Limpa o campo de mensagem apenas se o envio for bem-sucedido
      this.myForm.controls['msgControl'].setValue('');
      this.scrollToBottom();
      // Resposta paga: mantém o elogio que foi respondido (não força o primeiro)
      if (this.isPaidComplimentReply()) {
        this.keepPaidComplimentReplySelection();
      } else {
        this.respondedMessage = null;
        this.respondingMessage = false;
      }
    },
      err => {
        // Em caso de erro, mantém o texto original
        if (typeof msg != "object") {
          this.myForm.controls['msgControl'].setValue(msg);
        } else {
          this.myForm.controls['msgControl'].setValue('');
        }
        this.showForcedConnectionErrorToast();
        console.log('Error: ' + JSON.stringify(err));
      })
  }

  public dismiss() {

    // this.unregisterFunction();
    const contentElement = document.getElementById("contentDiv");
    if (contentElement == undefined || contentElement == null) {
      console.log("dismiss chat");
      return;
      // This should not happen anymore now that we call the unregisterFunction. Keeping it here just in case.
      // In the future, we may register the registerBackButtonAction method from app.component and deal with view.id == ChatPage or other pages
    }
    contentElement.classList.add('animation');

    console.log('fromVegmatchModal: ', this.fromVegmatchModal);


    if (this.fromVegmatchModal) {
      this.modalCtrl.dismiss();
      this.router.navigateByUrl('/tabs/chat-list');
    } else if (this.msgsSent > 0) {
      this.modalCtrl.dismiss('shouldRefreshList');
    } else if (this.clickValidateProfile) {
      this.modalCtrl.dismiss('initValidationProfile');
    } else {
      this.modalCtrl.dismiss(null);
    }
  }

  public scrollToBottom(duration = 300) {
    console.log('scrollToBottom...');
    if (this.content != undefined && this.content != null ) {
      console.log('Not null.. Will scroll...');
      // Com gate do elogio, espera o layout (input oculto / min-height) antes de ir ao fim,
      // para não deixar o chat “empurrado” para baixo.
      const delay = this.recadinhoReceiverGate || this.recadinhoSenderLock ? 80 : 0;
      setTimeout(() => {
        if (!this.content) {
          return;
        }
        if (typeof this.content.scrollToBottom === 'function') {
          this.content.scrollToBottom(duration);
        } else {
          this.content.scrollToPoint(0, 999999999, duration);
        }
      }, delay);
    }
    
    this.showFab = false;

  }

  /**
   * SK-54 — era um TOGGLE ligado a ionFocus E ionBlur. Os dois eventos chamavam o
   * mesmo metodo, entao o estado so ficava correto enquanto eles se alternassem
   * perfeitamente. Um focus perdido (ou um blur a mais, o que acontece justamente
   * quando o teclado pisca) invertia `userIsTyping` de forma permanente — e ele
   * governa o botao de rolar para o fim (`showFab`). Agora cada evento declara o
   * seu estado.
   *
   * Na web o foco ainda rola a conversa, porque o browser nao dispara
   * `keyboardDidShow`. No aparelho quem rola e esse evento, depois que o
   * teclado abriu — ver `ligarRolagemAposTeclado`.
   */
  public changeUserTypingState(isTyping: boolean) {
    this.userIsTyping = isTyping;
    if (isTyping && !this.isNative) {
      this.scrollToBottom();
    }
  }

  /** Identidade estavel da mensagem: sem isto o ngFor recria a lista a cada refresh. */
  public trackMessage(_index: number, aMessage: any): string {
    return aMessage?._id?.$oid ?? aMessage?._id ?? String(_index);
  }

  swipeEvent(e:any) {
    console.log('swiped');
    if (e == undefined || e == null || e.deltaX < 0) {
      // slide left
      return;
    }
    console.log(JSON.stringify(e));
    this.dismiss();

    // Check direction left to right
    // Check if works on other places this is opened
    // Can we have a better animation?
    //this.dismiss();
  }

  swipeEventAudio(e:any) {
    if (!this.mediaSP.recording) {
      return;
    }
    try {
      console.log('swiped');
      if (e == undefined || e == null || e.deltaX > 0) {
        // slide right
        return;
      }
      console.log(JSON.stringify(e));
      this.cancelAudio();

    } catch (error) {
      console.error(JSON.stringify(error), error);
    }
  }

  cancelAudio() {
    this.mediaSP.stopPreview();
    this.hasRecordedAudio = false;
    this.recordedAudioPath = null;
    this.mediaSP.stopRecord();
    this.mediaSP.deleteLastLocalAudioIfExists();
  }

  handleTouchStart(_message: any){
    // Implement animantion or logic for touch start if needed
  }

  handleTouchEnd(message: any) {
    const now = Date.now();
    const messageId = message?._id?.$oid;
    console.log("Clicked once")

    if (now - this.lastTap < this.doubleTapThreshold && this.lastTappedMessageId === messageId) {
      console.log("Double tap detected");
      this.handleMessageReaction(message);
      this.lastTap = 0;
      this.lastTappedMessageId = null;
    } else {
      console.log("Not fast or first tim")
      this.lastTap = now;
      this.lastTappedMessageId = messageId;
    }
  }

  handleMessageReaction(msg: any, reaction: number = 1) {
    if (msg.position != 'left') {
      return;
    }
    if (msg.reaction == 1) {
      this.userService.undoReactionToMessage(msg._id.$oid, reaction, this.userData).subscribe(async data => {
        console.log("UndoReactToMessage subscribe");
        console.log(data);

        const msgId = msg._id.$oid;
        const message = this.messagesMap.get(msgId);
        message.reaction = null;
        this.messagesMap.set(msgId, message);
        this.messages = Array.from(this.messagesMap.values());
      },
        error => {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          console.log(error);
        })
    } else {
      this.userService.reactToMessage(msg._id.$oid, reaction, this.userData).subscribe(async data => {
        console.log("ReactToMessage subscribe");
        console.log(data);

        const msgId = msg._id.$oid;
        const message = this.messagesMap.get(msgId);
        message.reaction = 1;
        message.reactionHint = false;
        this.messagesMap.set(msgId, message);
        this.messages = Array.from(this.messagesMap.values());
      },
        error => {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          console.log(error);
        })
    }
  }

  async showRespondMessage(msg: any, slidingItem: IonItemSliding) {
    this.respondedMessage = msg;
    this.respondingMessage = true;
    await slidingItem.close();
  }

  dismissRespondMessage() {
    this.respondingMessage = false;
    this.respondedMessage = null;
  }

scrollToRespondedMessage(respondedMsgId: string) {
  // Rola para a mensagem respondida (a ion-item-sliding)
  document.getElementById(respondedMsgId + '-sliding')?.scrollIntoView({ behavior: "smooth", block: "center" });

  // Adiciona a classe 'glow' à bolha da mensagem
  setTimeout(() => document.getElementById(respondedMsgId + "-bubble")?.classList.add("glow"), 300);

  // Remove a classe 'glow' da bolha da mensagem
  setTimeout(() => document.getElementById(respondedMsgId + "-bubble")?.classList.remove("glow"), 1050);
}

  async handleValidation(){
    // Verifica se não é Android nem iOS (web)
    if (!this.platform.is('android') && !this.platform.is('ios')) {
      this.showNotAvailableModal();
      return;
    }
    
    this.clickValidateProfile = true;
    if (this.fromProfileDisplay) {
      this.dismiss();
      return;
    }else {
      this.dismiss();
    }
    this.valitationService.openValidation();
  }

  async showNotAvailableModal() {
    const modal = await this.modalCtrl.create({
      component: NotAvailableComponent,
      componentProps: {
        downloadLink: environment.adjustDownloadLink
      },
      cssClass: 'custom-class-modal'
    });

    await modal.present();

    modal.onDidDismiss().then(() => {
      // Usuário permanece no chat
    });
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = "assets/imgs/no-picture.png"; // Caminho da imagem de fallback
  }

  /**
   * Ids de mensagens cuja foto do Elogio falhou ao carregar. Some com a miniatura via
   * *ngIf (sem manipular display inline no elemento, que ficaria preso no nó reaproveitado
   * pelo *ngFor e sumia com a foto de forma intermitente).
   */
  public failedComplimentPhotos: Set<string> = new Set<string>();

  onComplimentPhotoError(aMessage: any) {
    const id = aMessage?._id?.$oid;
    if (id) {
      this.failedComplimentPhotos.add(id);
    }
  }

  private async showForcedConnectionErrorToast() {
    // Ignora o controle de frequência do UtilService
    const toast = await this.toastCtrl.create({
      message: this.translate.instant('unableToConnectMsg'),
      position: 'top',
      duration: 4000,
      buttons: [
        {
          text: this.translate.instant('close'),
          role: 'cancel',
        }
      ],
    });
    toast.present();
  }
}
